<template>
	<div class="HeaderSapsucker">
		<div class="HeaderSapsucker-button" tabindex="-1">
			<img :src="`${logoBaseUrl}clo_sapsucker_web.svg`" alt="The Cornell Lab" />
			<span class="HeaderSapsucker-closer" tabindex="-1" aria-hidden="true"></span>
		</div>
		<div class="HeaderSapsucker-dropdown">
			<a href="https://birds.cornell.edu">
				<img :src="`${logoBaseUrl}clo_primary_web.svg`" alt="The Cornell Lab" />
			</a>
			<p>{{ $t('nav.labCredit') }}</p>
		</div>
	</div>
</template>

<script>
export default {
	name: 'CloHeaderSapsucker',
	data() {
		return {};
	},
	props: {
		logoBaseUrl: {
			type: String,
			default: 'https://clo-brand-static-prod.s3.amazonaws.com/logos/clo/',
		},
	},
	computed: {},
};
</script>

<style lang="scss">
.HeaderSapsucker {
	position: relative;
	display: flex;
	justify-content: flex-end;

	.HeaderSapsucker-button {
		padding: $space-sm $space-md;
		background-color: $brand-color-sand;
		display: none;
		img {
			height: 2.5rem;
			min-width: 3rem;
		}
		@include breakpoint(medium) {
			display: inline-flex;
			align-items: center;
		}
	}

	.HeaderSapsucker-closer {
		display: none;
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		margin: 0;
	}

	.HeaderSapsucker-dropdown {
		padding: $space-md;
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		gap: $space-sm;
		img {
			height: 2.5rem;
		}
		p {
			@include text(3);
			margin: 0;
		}
	}
	@include breakpoint(medium) {
		.HeaderSapsucker-dropdown {
			@include visuallyHidden;
		}
		&:focus-within {
			.HeaderSapsucker-dropdown {
				@include overrideVisuallyHidden;
				@include dropshadow-2;
				background: $color-white;
				display: flex;
				flex-direction: column;
				align-items: flex-start;
				position: absolute;
				inset-block-start: 100%;
				inset-inline-end: 0;
				min-width: 20rem;
			}
			.HeaderSapsucker-closer {
				display: inline-block; // unhide closer
			}
		}
	}
}
</style>
